module.exports = __webpack_public_path__ + "static/media/TO.661b4414.png";